import { Component } from '@angular/core';

@Component({
    selector: 'app-settings-menu',
    templateUrl: './settings-menu.component.html',
    styleUrls: ['./settings-menu.component.scss'],
    standalone: false
})
export class SettingsMenuComponent {
}
